module.exports = __webpack_public_path__ + "img/182.ed4bf335.jpg";